"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./MarketingHero.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarketingHero = function MarketingHero(_ref) {
  var desktopImage = _ref.desktopImage,
      tabletImage = _ref.tabletImage,
      mobileImage = _ref.mobileImage,
      children = _ref.children,
      buttonHref = _ref.buttonHref,
      buttonText = _ref.buttonText,
      allowLinkNewTab = _ref.allowLinkNewTab,
      containsChevron = _ref.containsChevron,
      logo = _ref.logo;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "marketing-hero"
  }, desktopImage && /*#__PURE__*/_react.default.createElement("img", {
    alt: "Hero",
    className: "desktop-image",
    src: desktopImage
  }), tabletImage && /*#__PURE__*/_react.default.createElement("img", {
    alt: "Hero",
    className: "tablet-image",
    src: tabletImage
  }), mobileImage && /*#__PURE__*/_react.default.createElement("img", {
    alt: "Hero",
    className: "mobile-image",
    src: mobileImage
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-body"
  }, containsChevron && /*#__PURE__*/_react.default.createElement("img", {
    className: "chevron",
    alt: "chevron",
    src: require("../assets/redesign2020/chevron-darker.svg")
  }), logo && /*#__PURE__*/_react.default.createElement("img", {
    className: "logo",
    alt: "logo",
    src: logo
  }), /*#__PURE__*/_react.default.createElement("h1", {
    className: "hero-text"
  }, children), buttonText && /*#__PURE__*/_react.default.createElement("a", {
    className: "button",
    href: buttonHref,
    target: allowLinkNewTab && "_blank"
  }, buttonText))));
};

MarketingHero.propTypes = {
  desktopImage: _propTypes.default.string,
  tabletImage: _propTypes.default.string,
  mobileImage: _propTypes.default.string,
  buttonLink: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  containsChevron: _propTypes.default.bool,
  logo: _propTypes.default.string
};
var _default = MarketingHero;
exports.default = _default;